import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';
import APIIntegration from '../../apiIntegration/pages/ApiIntegration';
import APIVersioningCard from './APIVersioningCard';
import SftpIngestionCard from './SftpIngestionCard';

const settingsCardSx = {
  backgroundColor: 'grey.900',
  borderRadius: 3,
};

export default function IntegrationSettingsSection() {
  const subscription = useSelector((state) => state.subscription.subscription);
  const isSftpEnabled = subscription?.features?.enable_sftp;

  return (
    <Stack spacing={3} sx={{ pb: 2 }}>
      <Box sx={settingsCardSx}>
        <APIIntegration />
      </Box>
      <Box sx={settingsCardSx}>
        <APIVersioningCard />
      </Box>
      {isSftpEnabled && (
        <Box sx={settingsCardSx}>
          <SftpIngestionCard />
        </Box>
      )}
    </Stack>
  );
}
